import { defineStore } from "pinia";
import jwt_decode from "jwt-decode";
import { apiAxios } from "@/api";

export const useAppStore = defineStore("app", {
  state: () => {
    return {
      isLoading: false,
      accessToken: localStorage.getItem("eip_access_token"),
      refreshToken: localStorage.getItem("eip_refresh_token"),
      imgUrl: "https://eip.pec.com.tw/images",
      unreadCount: 0,
      showChangeBioSettingDialog: false,
      iosVerify: false,
      leaveNotAllow: null,
      // IsSupportedBio: false,
      salaryKey: "HdM?@g.(#U",
      isSalaryLogin: false,
      salaryToken: "",
      salaryAlertMsg: "",
      navDrawerListsNew: [],
      // APIStatus: [],
      interfaceTime: [],
      areaCode: null,
      navDrawerError: false,
    };
  },
  getters: {
    userId(state) {
      return state.accessToken ? jwt_decode(state.accessToken).emp_no : "";
    },
    isLogin(state) {
      return !!state.userId;
    },
  },
  actions: {
    setToken({ access_token, refresh_token }) {
      this.accessToken = access_token;
      this.refreshToken = refresh_token;
      localStorage.eip_access_token = access_token;
      localStorage.eip_refresh_token = refresh_token;
      // if (window.EipJSInterface && window.EipJSInterface.setUserId) {
      //   window.EipJSInterface.setUserId(this.userId);
      // }
    },
    clearToken() {
      this.accessToken = "";
      this.refreshToken = "";
      localStorage.eip_access_token = "";
      localStorage.eip_refresh_token = "";
    },
    logout() {
      if (this.accessToken && this.userId) {
        if (window.EipJSInterface && window.EipJSInterface.onLogout) {
          window.EipJSInterface.onLogout(this.userId);
        }
        this.clearToken();
      }
    },
    refreshAccessToken() {
      let data = {
        refresh_token: this.refreshToken,
        client_id: process.env.VUE_APP_AUTH_CLIENT_ID,
        emp_no: this.userId,
      };
      let options = {
        method: "post",
        url: process.env.VUE_APP_ROOT_API + "/Account/RefreshToken",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      return apiAxios(options).then((res) => {
        return res;
      });
    },
    getNotificationLength() {
      return apiAxios({
        method: "post",
        url:
          process.env.VUE_APP_ROOT_API +
          "/NotificationCenter/GetUserUnreadCount",
        params: {},
        data: {},
      }).then((res) => {
        this.unreadCount =
          res.result.import_unread_count + res.result.personal_unread_count;
      });
    },
    setIosVerify(val) {
      this.iosVerify = val;
    },
    getLeaveFlag() {
      return apiAxios({
        method: "post",
        url: process.env.VUE_APP_LEAVE_API + "/Send",
        data: {
          apiName: "afl",
          url: "api/Lov/Get_Lov_Emp_Permission",
          data: {
            emp_no: this.userId,
          },
        },
      }).then((res) => {
        this.leaveNotAllow = res.Result[0].leave_flag == "N" ? true : false;
      });
    },
    setBadgeNumber(val) {
      if (window.EipJSInterface && window.EipJSInterface.updateBadgeNumber) {
        window.EipJSInterface.updateBadgeNumber(val ? val : 0);
      }
      this.unreadCount = val ? val : 0;
    },
    handleSelectMenu() {
      setTimeout(() => {
        let ele = document.querySelector(".v-menu__content");
        // console.dir(ele);
        if (ele) {
          ele.addEventListener("touchstart", function (event) {
            event.stopPropagation();
          });
          ele.addEventListener("touchmove", function (event) {
            event.stopPropagation();
          });
        }
      }, 10);
    },
    handleDialogOverlay() {
      setTimeout(() => {
        let ele = document.querySelector(".v-dialog--active");
        if (ele) {
          ele.addEventListener("touchstart", function (event) {
            event.stopPropagation();
          });
          ele.addEventListener("touchmove", function (event) {
            event.stopPropagation();
          });
        }
        let ele2 = document.querySelector(".v-overlay--active");
        if (ele2) {
          ele2.addEventListener("touchstart", function (event) {
            event.stopPropagation();
          });
          ele2.addEventListener("touchmove", function (event) {
            event.stopPropagation();
          });
        }
      }, 10);
    },
    getRoleUrl(parentId) {
      // let formData = new FormData();
      // formData.append("parent_id", `${parentId}`);
      return apiAxios({
        method: "post",
        url: process.env.VUE_APP_ROOT_API + "/Url/GetRoleUrl",
        data: `${parentId}`,
      }).then((res) => {
        return res.result;
      });
    },
    getOneTimeSalaryToken() {
      // 需確認是否能取得 userId，否則會出錯
      if (this.userId) {
        return apiAxios({
          method: "post",
          url: process.env.VUE_APP_LEAVE_API + "/Send",
          data: {
            apiName: "afl",
            url: "api/EIP/Get_Eip_CheckAuth",
            data: {
              emp_no: this.userId,
              key: this.salaryKey,
            },
          },
        }).then((res) => {
          // 當 pw_flag 回傳 null 時，表示驗證成功，此時才代入 salaryToken
          if (!JSON.parse(res.Message).pw_flag) {
            this.salaryToken = JSON.parse(res.Message).token;
          }
          this.salaryAlertMsg = res.Result[0].msg;
        });
      } else {
        return "";
      }
    },
    getNewNavDrawerLists() {
      return apiAxios({
        method: "post",
        url: process.env.VUE_APP_ROOT_API + "/Url/GetAllUrl",
        data: {
          leave_auth: this.leaveNotAllow ? "N" : "Y",
        },
      })
        .then((res) => {
          this.navDrawerListsNew = res.result;

          let settingId = this.navDrawerListsNew.findIndex(
            (e) => e.url == "/setting"
          );
          if (!window.EipJSInterface) {
            this.navDrawerListsNew.splice(settingId, 1);
          }

          if (window.EipJSInterface) {
            this.navDrawerListsNew.push({
              id: 0,
              name: "裝置版本",
              url: "/device-state",
              icon: "fa-solid fa-wrench",
            });
          }
        })
        .catch((error) => {
          console.log(error);

          this.navDrawerError = true;
        });
    },
    // setAPIStatus(val) {
    //   this.APIStatus.push(val);
    // },
  },
});
